import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'

const jqueryValidation = require('jquery-validation');


// Accept a value from a file input based on a required mimetype
$.validator.addMethod( "accept", function( value, element, param ) {

	// Split mime on commas in case we have multiple types we can accept
	var typeParam = typeof param === "string" ? param.replace( /\s/g, "" ) : "image/*",
		optionalValue = this.optional( element ),
		i, file, regex;

	// Element is optional
	if ( optionalValue ) {
		return optionalValue;
	}

	if ( $( element ).attr( "type" ) === "file" ) {

		// Escape string to be used in the regex
		// see: http://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
		// Escape also "/*" as "/.*" as a wildcard
		typeParam = typeParam
				.replace( /[\-\[\]\/\{\}\(\)\+\?\.\\\^\$\|]/g, "\\$&" )
				.replace( /,/g, "|" )
				.replace( /\/\*/g, "/.*" );

		// Check if the element has a FileList before checking each file
		if ( element.files && element.files.length ) {
			regex = new RegExp( ".?(" + typeParam + ")$", "i" );
			for ( i = 0; i < element.files.length; i++ ) {
				file = element.files[ i ];

				// Grab the mimetype from the loaded file, verify it matches
				if ( !file.type.match( regex ) ) {
					return false;
				}
			}
		}
	}

	// Either return true because we've validated each file, or because the
	// browser does not support element.files and the FileList feature
	return true;
}, $.validator.format( "Please enter a value with a valid mimetype." ) );



// Older "accept" file extension method. Old docs: http://docs.jquery.com/Plugins/Validation/Methods/accept
$.validator.addMethod( "extension", function( value, element, param ) {
	param = typeof param === "string" ? param.replace( /,/g, "|" ) : "png|jpe?g|gif";
	return this.optional( element ) || value.match( new RegExp( "\\.(" + param + ")$", "i" ) );
}, $.validator.format( "Please enter a value with a valid extension {0}." ) );



// polish letters added to jquery validation
jQuery.validator.addMethod('lettersOnly', function (value, element) {
    return this.optional(element) || /^[a-z A-ZąĄęĘżŻźŹćĆńŃŚśłŁóÓ\-]+$/i.test(value);
}, 'Dozwolone są tylko litery');

// polish letters added to jquery validation
jQuery.validator.addMethod('fullName', function (value, element) {
    return this.optional(element) || /^[a-z A-ZąĄęĘżŻźŹćĆńŃŚśłŁóÓ\-]+ [a-z A-ZąĄęĘżŻźŹćĆńŃŚśłŁóÓ\-]+$/i.test(value);
}, 'Podaj poprawnie "Imię i Nazwisko"');

// phone polish validatior
jQuery.validator.addMethod('phonePL', function (phone_number, element) {
    // phone_number = phone_number.replace(/\s+/g, '');
    return this.optional(element) || phone_number.length === 9;
}, 'Podaj poprawny "Numer telefonu"');

// kod pocztowy
jQuery.validator.addMethod("kodpocztowy", function (value, element) {
    return this.optional(element) || /^\d{2}-\d{3}$/.test(value);
}, "Wprowadź poprawny \"Kod pocztowy\"");

jQuery.validator.addMethod('filesize', function (value, element, param) {
    return this.optional(element) || (element.files[0].size <= param * 1000000)
}, 'Rozmiar pliku musi być mniejszy niż {0} MB');

// NIP validatior
jQuery.validator.addMethod('nip', function (value, element) {

    function validatenip(nip) {
        var nip_bez_kresek = nip.replace(/-/g, "");
        var reg = /^[0-9]{10}$/;
        if (reg.test(nip_bez_kresek) == false) {
            return false;
        } else {
            var dig = ("" + nip_bez_kresek).split("");
            var kontrola = (6 * parseInt(dig[0]) + 5 * parseInt(dig[1]) + 7 * parseInt(dig[2]) + 2 * parseInt(dig[3]) + 3 * parseInt(dig[4]) + 4 * parseInt(dig[5]) + 5 * parseInt(dig[6]) + 6 * parseInt(dig[7]) + 7 * parseInt(dig[8])) % 11;
            if (parseInt(dig[9]) == kontrola)
                return true;
            else
                return false;
        }

    }

    function isInArray(value, array) {
        return array.indexOf(value) > -1;
    }

    var isChecksumOK = validatenip(value);
    var disallow = ["1111111111", "2222222222", "3333333333", "4444444444", "5555555555", "6666666666", "7777777777", "8888888888", "9999999999", "0000000000"];
    var isDisallowed = isInArray(value, disallow);

    var response = !isDisallowed && isChecksumOK;

    return this.optional(element) || response;

}, 'Proszę o podanie prawidłowego "numeru NIP".');


class FileUploadField{
    input;
    $wrapper;
    constructor(el){
        this.input = el;
        this.$wrapper = $(this.input).parent();
        this.$label = this.$wrapper.find('.file-upload-field__name');
        this.$clear = this.$wrapper.find('.clear');
        $(this.input).on('input', this.onChange.bind(this));
        $(this.input.form).on('reset', this.onReset.bind(this));
        this.$clear .on('click', this.onClear.bind(this));
    }

    onChange(e){
        const files: FilesList = e.target.files;
        if(files.length){
            const file: File = files[0];

            this.$label.text(file.name);
            this.$clear.show();
        }else{
            const d = this.$label.data('default');
            this.$label.text(d);
        }
    }

    onReset(e){
       this.reset();
    }
    reset(){
        
        const d = this.$label.data('default');
        this.$label.text(d);
        this.$clear.hide();
        
    }
    onClear(e){
        this.input.value = '';
        this.reset();
    }

}

$('.file-upload-field input').each((i,el) => {
    new FileUploadField(el);
});

export const swalStyled = Swal.mixin({
    // title: "D",
    // text: message,
    html: '',
    // type: "error",
    customClass: {
        confirmButton: 'btn primary',
        cancelButton: 'btn primary'
    },
    buttonsStyling: false
});

window.swalStyled = swalStyled;

// Validators in js/validators.js

$("#contactForm").validate({
	ignore: ":hidden:not(:checkbox):not(:file)",
	rules: {
		name: {
			required: true,
			minlength: 3,
		},
		surname: {
			required: true,
			minlength: 3,
		},
		email: {
			required: true,
			email: true,
		},
		attachFile: {
		    required: false,
            extension: "jpg,jpeg,pdf,xlsx,docx,csv,png,bmp",
            filesize: 10,
		},
		phone: {
			required: false,
			// phonePL: true,
			// digits: true,
		},
		message: {
			required: true,
		},
		// countrye: {
		//     required: true,
		// },
		agree1: {
			required: true,
		},
		agree2: {
			required: true,
		},
		// agreed_regulamin: {
		//     required: true
		// }
	},
	invalidHandler: function (event, validator) {
		// 'this' refers to the form
		// console.log(event, validator);
		var errors = validator.numberOfInvalids();
		var errorList = validator.errorList;
		// var message = "Wprowadź proszę poprawne dane<br><ul>";
		var message = "<ul>";
		// + this.numberOfInvalids()

		for (var i = 0; i < errorList.length; i++) {
			var field = errorList[i];
			message += "<li>" + field.message + "</li>";
		}
		message += "</ul>";
		Swal.fire({
		    title: "Wprowadź poprawne dane",
		    // text: message,
		    html: message,
		    type: "error",
		    buttonsStyling: false,
		    confirmButtonClass: 'button'
		});
	},
	submitHandler: function (form) {
        
		// form.preventDefault();

		$(form).find("[type=submit]").attr("disabled", "disabled");

		// if (!window.grecaptcha.getResponse()) {
		// 	swalStyled.fire({
		// 		title: "Captcha",
		// 		html: `Confirm that you are not a robot`,
		// 	});
		// 	$(form).find("[type=submit]").removeAttr("disabled");
		// 	return false;
		// }

        const f = new FormData(form);

            $.ajax({
                type: "POST",
                enctype: 'multipart/form-data',
                url: $("#contactForm").attr("action"),
                data: f,
                processData: false,
                contentType: false,
                cache: false,
            })
			.then((data) => {
				console.log(data);
				if (!data.success) {
					// if (data.message) {
					// 	swalStyled.fire({
					// 		title: "Captcha",
					// 		html: data.message,
					// 	});
					// }
				} else {
					form.reset();
					swalStyled.fire({
						html: "Wiadomość została wysłana",
					});
				}

				$(window).trigger("resize");
				$(window).trigger("scroll");
				$(form).find("[type=submit]").removeAttr("disabled");
			})
			.fail((err) => {
				$(form).find("[type=submit]").removeAttr("disabled");

				swalStyled.fire({
					html: `Coś poszło nie tak`,
				});
			});
		// debugger;

		// form.submit();
	},
	messages: {
		name: {
			required: 'Wypełnij pole "Imię"',
			minlength: 'Pole "Imię" powinno zawierać minimum 3 znaki',
			// fullName: "Podaj poprawnie \"Imię i nazwisko\""
		},
		surname: {
			required: 'Wypełnij pole "Nazwisko"',
			minlength: 'Pole "Nazwisko" powinno zawierać minimum 3 znaki',
			// letersOnly: "Pole \"Nazwisko\" powinno zawierać tylko litery"
		},
        attachFile:{
            extension: 'Dozwolone formaty plików: {0}.',
            filesize: 'Maksymalny rozmiar pliku {0} MB.',
        },
		email: {
			required: 'Podaj prawidłowy adres "E-mail"',
			email: 'Podaj poprawny adres "E-mail"',
		},
		message: {
			required: 'Wypełnij pole "Wiadomość"',
		},
	},
	highlight: function (element) {
		$(element).addClass("error");
		// $(element).next('span').addClass('error-checkbox');
	},
	unhighlight: function (element) {
		$(element).removeClass("error");
		// $(element).next('span').removeClass('error-checkbox');
	},
	errorPlacement: function (error, element) {
		// $(error).appendTo(element.closest(".form-row"));
	},
});